import { render, staticRenderFns } from "./pesquisar-multas-valor.vue?vue&type=template&id=22d700aa&scoped=true&"
import script from "./pesquisar-multas-valor.vue?vue&type=script&lang=js&"
export * from "./pesquisar-multas-valor.vue?vue&type=script&lang=js&"
import style0 from "./pesquisar-multas-valor.vue?vue&type=style&index=0&id=22d700aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d700aa",
  null
  
)

export default component.exports